import {React, clickOn, _n, _s} from 'pexui';
import {DocUploadService} from '../services/docuploadsvc';
import {NavButton,Button,RadioButon,Link} from './comps/uicomps';
import {ELEM_ID_CONTENT, showModal} from './dialog';
import {flow, STATUS_NOT_READY, STATUS_MAYBE_READY, STATUS_COMPLETED} from '../models/flow';

import {PageHeader} from './comps/header';
import {PageFooter} from './comps/footer';

export class BasePage extends React.Component {
    constructor(props) {
        super(props);
    }

    hasHeader(){
        return this.props.widget.props.displayMode.indexOf('CAPTION') >= 0;
    }

    hasFooter(){
        return true;
    }

    getTitle() {
        return _n("widget.title");
    }

    hasBackButton() {
        return false;
    }

    hasHelp(){
        return true;
    }

    onBack(){

    }

    getFooterButtons(){
        const buttons = [];

        if(this.hasBackButton() && !this.hasHeader()){
            buttons.push({id: 'infw_btn_back',
                label: _n('footer.back'),
                isPrimary: false,
                onClick: (evt)=>this.onBack()
            });
        }
        
        const yodleeOnly = flow.isYodleeOnly();
        const readyStatus = flow.getReadyStatus();
        const cancelDisabled = readyStatus > STATUS_MAYBE_READY;
        const submitDisabled = readyStatus < STATUS_MAYBE_READY;
        if(yodleeOnly){
            if(readyStatus === STATUS_COMPLETED){
                buttons.push({id: 'infw_btn_submit',
                    className: 'infw-btn-primary',
                    label: _n('footer.submit'),
                    isPrimary: true,
                    onClick:(evt)=>this.props.widget.onSubmit()
                });
            }else{
                buttons.push({id: 'infw_btn_cancel',
                    className: 'infw-btn-secondary',
                    label: _n('yodlee.home.button_cancel') || _n('yodlee.tnc.button_cancel'),                
                    isPrimary: false,
                    onClick: (evt)=>this.props.widget.onClose()
                });
            }
        }else{
            buttons.push({id: 'infw_btn_cancel',
                label: _n('footer.cancel'),
                isPrimary: false,
                disabled: cancelDisabled,
                onClick:(evt)=>this.props.widget.onClose()
            });

            buttons.push({id: 'infw_btn_submit',
                label: _n('footer.submit'),
                isPrimary: true,
                disabled: submitDisabled,
                onClick:(evt)=>this.props.widget.onSubmit()
            });
        }
        return buttons;
    }

    // A sub class should overload this method to render the contents
    renderContent() {
        return '';
    }

    render() {
        const page = this;

        return (
          <div id={ELEM_ID_CONTENT} className="infw-page">
            <PageHeader
                visible={this.hasHeader()}
                title={this.getTitle()}
                onBack={this.hasBackButton() ? this.onBack.bind(this) : null}
                onClose={this.props.onClose}
            />
            <div className="infw-content">
                {this.renderContent()}
            </div>
            <PageFooter
                visible={this.hasFooter()}
                buttons={this.getFooterButtons()}
                hasHelp={this.hasHelp()}
            />
        </div>);
    }
}



// WEBPACK FOOTER //
// ./application/src/views/base.jsx